import { FC } from "react";
import SvgNavigateNext from "../icons/NagivateNext";
import SvgNavigateBefore from "../icons/NavigateBefore";
import Button from "./Button";
import styles from "./Pagination.module.css";

interface Props {
  from: number;
  to: number;
  total: number;
  onPrevious: () => void;
  onNext: () => void;
  canGoPrevious?: boolean;
  canGoNext?: boolean;
  previousLabel?: string;
  nextLabel?: string;
  showNavigation?: boolean;
}

const Pagination: FC<Props> = ({
  from,
  to,
  total,
  onPrevious,
  onNext,
  canGoPrevious = true,
  canGoNext = true,
  previousLabel,
  nextLabel,
  showNavigation = true,
}: Props) => (
  <div className={styles.controls}>
    <div>
      {from} - {to} of {total}
    </div>
    {showNavigation && (
      <div className={styles.pagination}>
        <Button
          glyph={SvgNavigateBefore}
          buttonProps={{
            title: previousLabel,
            disabled: !canGoPrevious,
            onClick: onPrevious,
            className: styles.paginationButton,
          }}
        />
        <Button
          glyph={SvgNavigateNext}
          buttonProps={{
            title: nextLabel,
            disabled: !canGoNext,
            onClick: onNext,
            className: styles.paginationButton,
          }}
        />
      </div>
    )}
  </div>
);

export default Pagination;
